(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[563],{

/***/ 9737:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/people",
      function () {
        return __webpack_require__(8373);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ people; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/transition/dist/esm/slide-fade.js
var slide_fade = __webpack_require__(454);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/esm/text.js
var esm_text = __webpack_require__(4115);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/esm/box.js
var box = __webpack_require__(8017);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/esm/flex.js
var flex = __webpack_require__(4096);
// EXTERNAL MODULE: ./src/components/Layout/index.ts + 11 modules
var Layout = __webpack_require__(8077);
// EXTERNAL MODULE: ./src/components/Link/index.ts + 1 modules
var Link = __webpack_require__(8030);
// EXTERNAL MODULE: ./src/components/Image/index.ts + 1 modules
var Image = __webpack_require__(8331);
;// CONCATENATED MODULE: ./public/people/1.jpg
/* harmony default export */ var _1 = ({"src":"/_next/static/media/1.d8a2f709.jpg","height":527,"width":973,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAQACAMBIgACEQEDEQH/xAAnAAEBAAAAAAAAAAAAAAAAAAAABgEBAAAAAAAAAAAAAAAAAAAABf/aAAwDAQACEAMQAAAAmgch/8QAHBAAAAYDAAAAAAAAAAAAAAAAAQIDBBEhAAUS/9oACAEBAAE/AGmwcKpB1FtynqQvP//EABcRAAMBAAAAAAAAAAAAAAAAAAABESH/2gAIAQIBAT8Airw//8QAFxEBAAMAAAAAAAAAAAAAAAAAAQARIf/aAAgBAwEBPwAWjZ//2Q=="});
;// CONCATENATED MODULE: ./public/people/2.jpg
/* harmony default export */ var _2 = ({"src":"/_next/static/media/2.e4ff57d6.jpg","height":532,"width":948,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAQACAMBIgACEQEDEQH/xAAnAAEBAAAAAAAAAAAAAAAAAAAAAQEBAAAAAAAAAAAAAAAAAAAABf/aAAwDAQACEAMQAAAAoIT/AP/EABsQAAIDAAMAAAAAAAAAAAAAAAECAwQRAAUS/9oACAEBAAE/AK/ZTzRVlKxqRjB1GMDvnn//xAAWEQEBAQAAAAAAAAAAAAAAAAABEQD/2gAIAQIBAT8ArXf/xAAWEQADAAAAAAAAAAAAAAAAAAAAAUH/2gAIAQMBAT8AiP/Z"});
;// CONCATENATED MODULE: ./public/people/3.jpg
/* harmony default export */ var _3 = ({"src":"/_next/static/media/3.fc788db5.jpg","height":527,"width":972,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAQACAMBIgACEQEDEQH/xAAnAAEBAAAAAAAAAAAAAAAAAAAABQEBAAAAAAAAAAAAAAAAAAAABP/aAAwDAQACEAMQAAAAsgK//8QAHBAAAgICAwAAAAAAAAAAAAAAAQMCBQAEESJC/9oACAEBAAE/AK7ecyycgCC4AsPSPHsjP//EABgRAAIDAAAAAAAAAAAAAAAAAAABAzFx/9oACAECAQE/AI6en//EABgRAAIDAAAAAAAAAAAAAAAAAAABAjFx/9oACAEDAQE/AJ2sP//Z"});
;// CONCATENATED MODULE: ./public/people/rana.png
/* harmony default export */ var rana = ({"src":"/_next/static/media/rana.c03614e7.png","height":510,"width":404,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAApElEQVR42hWMMQoCMRREc2o7Sy8gIhZaeQgRBAVBPYCgsKtiWEGwWBOTbLI/+WPy4E3zYESMUYaeTE9RMaCY2WSloOCtaz/wPwVwyjJysAKx16AOCJbZG0aKYEAL5OmcAxGhwEVmLcy31Y/5EO1xjUJKCakEXZ91NRngshwzec8olKvojL0vRnjtVijUjcfzHazY7E9yM5ua22GriKO6Sm+qxss/wuuzbW733DwAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./public/people/rajiv.png
/* harmony default export */ var rajiv = ({"src":"/_next/static/media/rajiv.06c8095d.png","height":510,"width":404,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAApElEQVR42iWMMQrCMBhGczhv4XUUHHRSB0F06OzsIDh4BEHsItWgUBSUhPw2aZrvU9oHb3nDU7FpdKij+2sAGJAOgFbRVyKfF8W8idSQKRFIohBry+DIIED4gl6IGKwiaUMia7AFnVZZEZuNRzzvt0gkATAlWPUon3be77FYD+CrCuxoV7KZTXjKpm25lYGXuxeVl04Pxyu3Wy7M4erMsRCXa69/TSixNtFRrTsAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./public/people/team.png
/* harmony default export */ var team = ({"src":"/_next/static/media/team.f4713076.png","height":1248,"width":459,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAICAYAAAA870V8AAAAc0lEQVR4nAFoAJf/AaKPczsFABCKy8bUdgGhioWB/w8Tftjc4IUBsLu0ff/2+4INCQeIAbOZkJf9/fZoExobnAGVfHibBwwLZDQ6No8Bwrq5lObg3Gv4/ftoAaqflKH7+v1eGRsglAG/uLR859zbMuvp9Mpg0DZzHGMePAAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./public/people/bg-circle-top.png
/* harmony default export */ var bg_circle_top = ({"src":"/_next/static/media/bg-circle-top.c9b6e3a8.png","height":1072,"width":974,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAAlUlEQVR42lWO0QqCQBRE5643pZcgCqL//zYzU7LSDKXdaTB66MAuhzkv18rqAVGEYHu9Qs4Y09Mza73p5lxyNEOWiGSAyTeJXPm5HXbAEqJGA0EC7xBQeNmMBRQ0C9kPIvmp7rkE4h9tXjXjJFubIXKZvl8izS/ddI0xHkgGMyME5bp88qrtZwC1MWyZkMtVMNzn1+0DhAtNeRAFqasAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./public/people/bg-circle-center.png
/* harmony default export */ var bg_circle_center = ({"src":"/_next/static/media/bg-circle-center.8a95f66a.png","height":515,"width":399,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAAfElEQVR42mXLywrCMABE0TtJwAfuXIj//21Wq/GBVUoszWhXIp5ZDldNe9/EEJaAanUZqzNQUr6+VgZPU2DuynYYa5N2bVeZCDCjpCixTvtTb/gyTOcs7Y6d4V865P4nsIng/lM8kTCAjSSGGOM55Vt51OoFoBBUjC/A8AbNYkNG9dObTwAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./public/people/bg-circle-bottom.png
/* harmony default export */ var bg_circle_bottom = ({"src":"/_next/static/media/bg-circle-bottom.e7671a10.png","height":1330,"width":1224,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAAm0lEQVR42kVMSQ7CMAy0nTQsFxaBEP//CjfeUUpLG6FWSikiMRNRibnYs3J57wlYiPBRmB1+jTEN+826s1X7coWRMzMZVU3EGbSt/VTY1ocDRJOUIkRGE5Q+Rnhlb4/RgcUcB5Rm5BVb1r3CmNU/chTNMOEuEUhI8Oygp2IbP/oY9YQZ4Sz+xkUMB1s14Q1ao7mD4/AjRcPl2j2/QsZUC+AdhDYAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./public/people/bg-circle-join-team.png
/* harmony default export */ var bg_circle_join_team = ({"src":"/_next/static/media/bg-circle-join-team.89e6e035.png","height":703,"width":615,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAclBMVEXX3e1JZ7PL0+lUcLc8XKzl6PLk5/E+Xq09XK1qgb+3wt/m6fJSbbVRbbU7Wq1rgsBRbbWDlslrgsBqgb/R1+vQ1+u1wN+erdaerNadrNaEl8mDlslQbLW2wd+2wN9qgb/p6/PR1+vQ1+u3wd+3wt/S2OtF6GTmAAAAJnRSTlMAAAUFBQYGBhYYGRocHR0eHh8fHyAgICAgICAgICEhISIiIiIjJMRr3j8AAABCSURBVHjaDcEJAoAQFAXA166U9FuJUrj/FZlBy53jDbDF7497Cf9Ye4QB6srUCX1nesFKRPPbYzJSmrFCx4RgdZEAmeUEXzpPt2MAAAAASUVORK5CYII="});
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
;// CONCATENATED MODULE: ./src/pages/people/index.tsx

















var People = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(head["default"], {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "101Digital | Team"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(slide_fade/* SlideFade */.R, {
                in: true,
                offsetY: "50px",
                transition: {
                    enter: {
                        duration: 1
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_text/* Text */.x, {
                    as: "h1",
                    textStyle: "h1",
                    textAlign: [
                        "center",
                        null,
                        null,
                        null,
                        null,
                        "left"
                    ],
                    display: "flex",
                    flexDir: [
                        "column",
                        null,
                        null,
                        null,
                        null,
                        "row"
                    ],
                    mt: [
                        "45px",
                        null,
                        null,
                        null,
                        null,
                        "132px"
                    ],
                    mb: [
                        "13px",
                        null,
                        null,
                        null,
                        null,
                        8
                    ],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                            children: "The People &"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                            color: "secondary",
                            ml: 4,
                            children: "The Vision"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                textStyle: "paragraphHighlighted",
                textAlign: [
                    "center",
                    null,
                    null,
                    null,
                    null,
                    "left"
                ],
                px: [
                    "61px",
                    null,
                    null,
                    null,
                    null,
                    0
                ],
                fontWeight: 300,
                children: "Our motivation for great digital products goes back to our founders' story."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(box/* Box */.xu, {
                position: "relative",
                width: "100%",
                maxWidth: "1152px",
                margin: "0 auto",
                padding: [
                    "46px 0 43px",
                    null,
                    null,
                    null,
                    null,
                    "160px 16px 70px",
                    "160px 0 70px",
                    null,
                    null,
                    "160px 0 70px", 
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(box/* Box */.xu, {
                        position: "absolute",
                        top: "0",
                        right: "-384px",
                        pointerEvents: "none",
                        zIndex: -1,
                        display: [
                            "none",
                            null,
                            null,
                            "block"
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: bg_circle_top,
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(box/* Box */.xu, {
                        position: "absolute",
                        top: "35%",
                        left: "-384px",
                        pointerEvents: "none",
                        zIndex: -1,
                        display: [
                            "none",
                            null,
                            null,
                            "block"
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: bg_circle_center,
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(box/* Box */.xu, {
                        position: "absolute",
                        bottom: "8%",
                        right: "-384px",
                        pointerEvents: "none",
                        zIndex: -1,
                        display: [
                            "none",
                            null,
                            null,
                            "block"
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: bg_circle_bottom,
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                        flexDir: [
                            "column",
                            null,
                            null,
                            null,
                            null,
                            "row"
                        ],
                        align: "center",
                        w: "100%",
                        mb: [
                            "54.11px",
                            null,
                            null,
                            null,
                            null,
                            "132px"
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(slide_fade/* SlideFade */.R, {
                                in: true,
                                offsetX: "-200px",
                                transition: {
                                    enter: {
                                        duration: 1
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(box/* Box */.xu, {
                                    flex: [
                                        "0 0 100%",
                                        null,
                                        null,
                                        null,
                                        null,
                                        "52%"
                                    ],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: _1,
                                        alt: "tech teams working together towards product delivery"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                                flex: [
                                    "0 0 100%",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "48%"
                                ],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(slide_fade/* SlideFade */.R, {
                                    in: true,
                                    offsetY: "50px",
                                    transition: {
                                        enter: {
                                            duration: 1
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                                        textStyle: "paragraph",
                                        p: [
                                            "46px 61px 0px",
                                            null,
                                            null,
                                            null,
                                            null,
                                            "0 16px 0px 32px",
                                            null,
                                            "0 0 0 86px", 
                                        ],
                                        textAlign: [
                                            "center",
                                            null,
                                            null,
                                            null,
                                            null,
                                            "start"
                                        ],
                                        whiteSpace: [
                                            "normal",
                                            null,
                                            null,
                                            null,
                                            null,
                                            "pre-line"
                                        ],
                                        fontSize: [
                                            "14px",
                                            null,
                                            null,
                                            null,
                                            null,
                                            "21px"
                                        ],
                                        fontWeight: "300",
                                        children: "Rana & Rajiv, our founders, have spent the last decade working with global banks and their digital transformation journeys. And they noticed the recurring challenge of delivering digital products."
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                        align: "center",
                        w: "100%",
                        mb: [
                            "46.8px",
                            null,
                            null,
                            null,
                            null,
                            "140px"
                        ],
                        flexDir: [
                            "column",
                            null,
                            null,
                            null,
                            null,
                            "row-reverse"
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(slide_fade/* SlideFade */.R, {
                                in: true,
                                offsetX: "200px",
                                transition: {
                                    enter: {
                                        duration: 1
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(box/* Box */.xu, {
                                    flex: [
                                        "0 0 100%",
                                        null,
                                        null,
                                        null,
                                        null,
                                        "52%"
                                    ],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: _2,
                                        alt: "planning a quick product delivery"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                                flex: [
                                    "0 0 100%",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "48%"
                                ],
                                justify: "flex-end",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(slide_fade/* SlideFade */.R, {
                                    in: true,
                                    offsetY: "50px",
                                    transition: {
                                        enter: {
                                            duration: 1
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                                        textStyle: "paragraph",
                                        p: [
                                            "46px 61px 0px",
                                            null,
                                            null,
                                            null,
                                            null,
                                            "0 32px 0px 16px",
                                            null,
                                            "0 86px 0 0", 
                                        ],
                                        textAlign: [
                                            "center",
                                            null,
                                            null,
                                            null,
                                            null,
                                            "start"
                                        ],
                                        whiteSpace: [
                                            "normal",
                                            null,
                                            null,
                                            null,
                                            null,
                                            "pre-line"
                                        ],
                                        fontSize: [
                                            "14px",
                                            null,
                                            null,
                                            null,
                                            null,
                                            "21px"
                                        ],
                                        fontWeight: "300",
                                        children: "Banks and neo banks were struggling with getting products to market. Even with a clear vision and articulate strategy, product delivery and launch didn’t go to plan. Cost-intensive product creation and lack of technical expertise either delay or deter products from moving from concept to delivery."
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                        flexDir: [
                            "column",
                            null,
                            null,
                            null,
                            null,
                            "row"
                        ],
                        align: "center",
                        w: "100%",
                        mb: [
                            "98px",
                            null,
                            null,
                            null,
                            null,
                            "196px"
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(slide_fade/* SlideFade */.R, {
                                in: true,
                                offsetX: "-200px",
                                transition: {
                                    enter: {
                                        duration: 1
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(box/* Box */.xu, {
                                    flex: [
                                        "0 0 100%",
                                        null,
                                        null,
                                        null,
                                        null,
                                        "52%"
                                    ],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: _3,
                                        alt: "launching products in shorter time"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                                flex: [
                                    "0 0 100%",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "48%"
                                ],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(slide_fade/* SlideFade */.R, {
                                    in: true,
                                    offsetY: "50px",
                                    transition: {
                                        enter: {
                                            duration: 1
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                                        textStyle: "paragraph",
                                        p: [
                                            "46px 61px 0px",
                                            null,
                                            null,
                                            null,
                                            null,
                                            "0 16px 0px 32px",
                                            null,
                                            "0 0 0 86px", 
                                        ],
                                        textAlign: [
                                            "center",
                                            null,
                                            null,
                                            null,
                                            null,
                                            "start"
                                        ],
                                        whiteSpace: [
                                            "normal",
                                            null,
                                            null,
                                            null,
                                            null,
                                            "pre-line"
                                        ],
                                        fontSize: [
                                            "14px",
                                            null,
                                            null,
                                            null,
                                            null,
                                            "21px"
                                        ],
                                        fontWeight: "300",
                                        children: "Rana and Rajiv created 101 Digital to simplify and accelerate the delivery of digital platforms. It is our mission to help businesses create phenomenal digital experiences. So every consumer, ourselves included, can enjoy them."
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                        as: "h2",
                        textStyle: "h2",
                        textAlign: "center",
                        fontSize: [
                            "18px",
                            null,
                            null,
                            null,
                            null,
                            "48px"
                        ],
                        fontWeight: "300",
                        mb: [
                            "54px",
                            null,
                            null,
                            null,
                            null,
                            "153px"
                        ],
                        children: "Founders"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                        flexDir: [
                            "column",
                            null,
                            null,
                            null,
                            null,
                            "row"
                        ],
                        justify: "center",
                        w: "100%",
                        mb: [
                            "64px",
                            null,
                            null,
                            null,
                            null,
                            "110px"
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(box/* Box */.xu, {
                                position: "relative",
                                px: [
                                    "24px",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "0px"
                                ],
                                m: [
                                    "auto",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "0"
                                ],
                                textAlign: [
                                    "center",
                                    null,
                                    null,
                                    null,
                                    "left"
                                ],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: rana,
                                        alt: "101D"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        position: "absolute",
                                        width: "70px",
                                        height: "70px",
                                        bottom: [
                                            "7.5%",
                                            null,
                                            null,
                                            "39px"
                                        ],
                                        right: [
                                            "13.5%",
                                            null,
                                            null,
                                            "38px"
                                        ],
                                        href: "https://sg.linkedin.com/in/ranaperies",
                                        target: "_blank",
                                        opacity: 0,
                                        borderRadius: "50%",
                                        onClick: function() {
                                            return window.open("https://sg.linkedin.com/in/ranaperies", "_blank");
                                        },
                                        children: " "
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(box/* Box */.xu, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_text/* Text */.x, {
                                            textStyle: "paragraph",
                                            ml: [
                                                "0px",
                                                null,
                                                null,
                                                null,
                                                null,
                                                "104px"
                                            ],
                                            textAlign: [
                                                "center",
                                                null,
                                                null,
                                                null,
                                                null,
                                                "start"
                                            ],
                                            whiteSpace: [
                                                "normal",
                                                null,
                                                null,
                                                null,
                                                null,
                                                "pre-line"
                                            ],
                                            fontSize: [
                                                "12px",
                                                null,
                                                null,
                                                null,
                                                null,
                                                "21px"
                                            ],
                                            fontWeight: "300",
                                            p: [
                                                "48px 29px 0px",
                                                null,
                                                null,
                                                null,
                                                null,
                                                "0px"
                                            ],
                                            children: [
                                                "Rana is the CTO & co-founder of 101 Digital.",
                                                "\n",
                                                " Before founding 101 Digital, Rana was the",
                                                "\n",
                                                " Director, Innovation & Digital Services at",
                                                "\n",
                                                " Barclays Bank and the Head of Innovation",
                                                "\n",
                                                " and Digital Financial Services at the",
                                                "\n",
                                                " Commonwealth Bank of Australia."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_text/* Text */.x, {
                                            textStyle: "paragraph",
                                            ml: [
                                                "0px",
                                                null,
                                                null,
                                                null,
                                                null,
                                                "104px"
                                            ],
                                            textAlign: [
                                                "center",
                                                null,
                                                null,
                                                null,
                                                null,
                                                "start"
                                            ],
                                            whiteSpace: [
                                                "normal",
                                                null,
                                                null,
                                                null,
                                                null,
                                                "pre-line"
                                            ],
                                            fontSize: [
                                                "12px",
                                                null,
                                                null,
                                                null,
                                                null,
                                                "21px"
                                            ],
                                            fontWeight: "300",
                                            p: [
                                                "20px 29px 0px",
                                                null,
                                                null,
                                                null,
                                                null,
                                                "0px"
                                            ],
                                            children: [
                                                "\n",
                                                " Rana has helped large regional and",
                                                "\n",
                                                " international financial services organizations",
                                                "\n",
                                                " shape new digital experiences. He has also",
                                                "\n",
                                                "worked with FinTechs to implement",
                                                "\n",
                                                " comprehensive open banking, digital",
                                                "\n",
                                                " banking, neobank, and embedded finance",
                                                "\n",
                                                " platforms for retail, corporate, SME and",
                                                "\n",
                                                " insurance businesses."
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                        flexDir: [
                            "column",
                            null,
                            null,
                            null,
                            null,
                            "row-reverse"
                        ],
                        justify: "center",
                        w: "100%",
                        mb: [
                            "70px",
                            0
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(box/* Box */.xu, {
                                position: "relative",
                                px: [
                                    "24px",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "0px"
                                ],
                                m: [
                                    "auto",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "0"
                                ],
                                textAlign: [
                                    "center",
                                    null,
                                    null,
                                    null,
                                    "left"
                                ],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: rajiv,
                                        alt: "101D"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        position: "absolute",
                                        width: "70px",
                                        height: "70px",
                                        bottom: [
                                            "7.5%",
                                            null,
                                            null,
                                            "39px"
                                        ],
                                        right: [
                                            "13.5%",
                                            null,
                                            null,
                                            "38px"
                                        ],
                                        href: "https://sg.linkedin.com/in/rajiv-ellepola-476b5b1",
                                        target: "_blank",
                                        opacity: 0,
                                        borderRadius: "50%",
                                        onClick: function() {
                                            return window.open("https://sg.linkedin.com/in/rajiv-ellepola-476b5b1", "_blank");
                                        },
                                        children: " "
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(box/* Box */.xu, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_text/* Text */.x, {
                                            textStyle: "paragraph",
                                            mr: [
                                                "0px",
                                                null,
                                                null,
                                                null,
                                                null,
                                                "104px"
                                            ],
                                            textAlign: [
                                                "center",
                                                null,
                                                null,
                                                null,
                                                null,
                                                "start"
                                            ],
                                            whiteSpace: [
                                                "normal",
                                                null,
                                                null,
                                                null,
                                                null,
                                                "pre-line"
                                            ],
                                            fontSize: [
                                                "12px",
                                                null,
                                                null,
                                                null,
                                                null,
                                                "21px"
                                            ],
                                            fontWeight: "300",
                                            p: [
                                                "48px 29px 0px",
                                                null,
                                                null,
                                                null,
                                                null,
                                                "0px"
                                            ],
                                            children: [
                                                "Rajiv is the co-founder and head of delivery",
                                                "\n",
                                                " and operations at 101 Digital. Before his role",
                                                "\n",
                                                " at 101 Digital, Rajiv was Director of Digital",
                                                "\n",
                                                " Platform & Experimentation for Barclays.",
                                                "\n",
                                                " Previously he held several leadership roles,",
                                                "\n",
                                                " including Head of Platform Delivery, Deputy",
                                                "\n",
                                                " CIO, Domain Lead Architect for",
                                                "\n",
                                                " Commonwealth Bank of Australia."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_text/* Text */.x, {
                                            textStyle: "paragraph",
                                            mr: [
                                                "0px",
                                                null,
                                                null,
                                                null,
                                                null,
                                                "104px"
                                            ],
                                            textAlign: [
                                                "center",
                                                null,
                                                null,
                                                null,
                                                null,
                                                "start"
                                            ],
                                            whiteSpace: [
                                                "normal",
                                                null,
                                                null,
                                                null,
                                                null,
                                                "pre-line"
                                            ],
                                            fontSize: [
                                                "12px",
                                                null,
                                                null,
                                                null,
                                                null,
                                                "21px"
                                            ],
                                            fontWeight: "300",
                                            p: [
                                                "20px 29px 0px",
                                                null,
                                                null,
                                                null,
                                                null,
                                                "0px"
                                            ],
                                            children: [
                                                "\n",
                                                " Rajiv has led architecture, project office,",
                                                "\n",
                                                " development, and deployment teams to",
                                                "\n",
                                                " deliver complex digital solutions within large",
                                                "\n",
                                                " enterprises. He is passionate about",
                                                "\n",
                                                " implementing low-cost solutions to",
                                                "\n",
                                                " challenging problems through good design",
                                                "\n",
                                                " and smart engineering."
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                position: "relative",
                flexDir: [
                    "column-reverse",
                    null,
                    null,
                    null,
                    null,
                    "row"
                ],
                justify: "center",
                w: "100%",
                px: "16px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(box/* Box */.xu, {
                        pos: "absolute",
                        top: "-140px",
                        left: "0",
                        display: [
                            "none",
                            null,
                            null,
                            null,
                            null,
                            "block"
                        ],
                        zIndex: "-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: bg_circle_join_team,
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                        justify: [
                            "center",
                            null,
                            null,
                            null,
                            null,
                            "flex-end"
                        ],
                        p: [
                            "68px 64px 211.73px",
                            null,
                            null,
                            null,
                            null,
                            "138px 132px 138px 0px", 
                        ],
                        w: [
                            "100%",
                            null,
                            null,
                            null,
                            null,
                            "50%"
                        ],
                        bgImage: [
                            "url('/circuit-board-white-small.png')",
                            null,
                            null,
                            null,
                            null,
                            "none", 
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: team,
                            alt: "101D"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                        w: [
                            "100%",
                            null,
                            null,
                            null,
                            null,
                            "50%"
                        ],
                        bgImage: "url('/circuit-board-white-small.png')",
                        flexDir: "column",
                        justify: "center",
                        pt: [
                            "166px",
                            null,
                            null,
                            null,
                            null,
                            "0px"
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                                as: "h1",
                                textStyle: "h1",
                                fontSize: [
                                    "28.28px",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "46px"
                                ],
                                lineHeight: [
                                    "31.44px",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "52px"
                                ],
                                mb: [
                                    "31.45px",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "50px"
                                ],
                                textAlign: [
                                    "center",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "start"
                                ],
                                children: "Join our team"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_text/* Text */.x, {
                                textStyle: "paragraph",
                                mb: [
                                    "50px",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "44px"
                                ],
                                fontSize: [
                                    "14px",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "21px"
                                ],
                                fontWeight: "300",
                                whiteSpace: [
                                    "normal",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "pre-line"
                                ],
                                px: [
                                    "68px",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "0px"
                                ],
                                textAlign: [
                                    "center",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "start"
                                ],
                                children: [
                                    "Work with a team that is fast paced, highly skilled",
                                    "\n",
                                    " and most importantly, looking out for each other."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                                as: "h1",
                                textStyle: "h1",
                                fontSize: [
                                    "14px",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "24px"
                                ],
                                lineHeight: [
                                    "20px",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "30px"
                                ],
                                textAlign: [
                                    "center",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "start"
                                ],
                                fontWeight: [
                                    "400",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "700"
                                ],
                                px: [
                                    "88px",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "0px"
                                ],
                                children: "Send your CV to recruitment@101digital.io"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var people = (People);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [425,454,77,774,888,179], function() { return __webpack_exec__(9737); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);